import {
  Title,
  DetailsSection,
  PARAGRAPH,
  SUBTITLE,
  TITLE
} from '../components';
import { TVNZ_CONTACT_LINK } from '../components/Title/constants';

const FirstPage = () => {
  return (
    <div>
      <Title
        Title={TITLE.CAMPAIGN_DETAILS}
        Subtitle={SUBTITLE.STEP_ONE}
        Paragraph={PARAGRAPH.PARAGRAPH_ONE}
        Link={TVNZ_CONTACT_LINK}
      />
      <DetailsSection />
    </div>
  );
};

export default FirstPage;
